/**
 * @generated SignedSource<<c7f0d456273a4fefa58fec8e4c5577dd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IHKCertificateOrderStateKind = "ErrorOccurred" | "NotIHK" | "Ordered" | "ReadyToOrder" | "RewardNotAchievedYet";
export type UnlockInfoKind = "Demo" | "ErrorOccurred" | "FullAccess" | "WallNotFound";
export type ViewerTreeStateKind = "CanBeStarted" | "CanNotBeStarted" | "IsFinished" | "IsStarted" | "NotVisible";
export type root_GetRootQuery$variables = {
  id: string;
};
export type root_GetRootQuery$data = {
  readonly node: {
    readonly root?: {
      readonly instructorsV2: {
        readonly edges: ReadonlyArray<{
          readonly __typename: "InstructorsEdge";
        } | null> | null;
      };
      readonly structureDefinition: {
        readonly extension?: {
          readonly ihkState?: IHKCertificateOrderStateKind;
          readonly learnGoals?: string | null;
          readonly product?: {
            readonly id: string;
            readonly title: string;
          } | null;
          readonly reducedData?: {
            readonly isIHK: boolean;
            readonly receivableGamificationPoints: number;
          } | null;
          readonly trailer?: {
            readonly url: string | null;
          } | null;
          readonly unlockInfo?: {
            readonly kind: UnlockInfoKind;
          };
        };
        readonly title: string;
        readonly viewerTreeState?: {
          readonly headContentId?: string;
          readonly kind: ViewerTreeStateKind;
        };
      };
      readonly typeDefinition: {
        readonly children?: ReadonlyArray<{
          readonly typeDefinition: {
            readonly children?: ReadonlyArray<{
              readonly id: string;
            }>;
          };
        }>;
      };
      readonly " $fragmentSpreads": FragmentRefs<"RootProgress_LearnOpportunityV2Fragment" | "branchNodesTab_LearnOpportunityV2Fragment" | "materialsTab_LearnOpportunityV2Fragment">;
    } | null;
  } | null;
};
export type root_GetRootQuery = {
  response: root_GetRootQuery$data;
  variables: root_GetRootQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "receivableGamificationPoints",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "ReducedData",
  "kind": "LinkedField",
  "name": "reducedData",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isIHK",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "product",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "learnGoals",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ihkState",
  "storageKey": null
},
v11 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "headContentId",
      "storageKey": null
    }
  ],
  "type": "IsStartedViewerTreeState",
  "abstractKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "InstructorsConnection",
  "kind": "LinkedField",
  "name": "instructorsV2",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "InstructorsEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        (v12/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v14 = [
  (v6/*: any*/),
  (v7/*: any*/)
],
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": (v14/*: any*/),
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "structureDefinition",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "indexPath",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentKind",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "extension",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "receivedGamificationPoints",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isUnlockNecessaryToStart",
          "storageKey": null
        }
      ],
      "type": "LearnContentExtensionImpl",
      "abstractKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "root_GetRootQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LearnOpportunityV2",
                "kind": "LinkedField",
                "name": "root",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "RootProgress_LearnOpportunityV2Fragment"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "structureDefinition",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "extension",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v4/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "unlockInfo",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "StreamFile",
                                    "kind": "LinkedField",
                                    "name": "trailer",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v8/*: any*/),
                                  (v9/*: any*/),
                                  (v10/*: any*/)
                                ],
                                "type": "PublishedRootExtensionImpl",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "viewerTreeState",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v11/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "LearnOpportunityRootStructureDefinition",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "typeDefinition",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LearnOpportunityV2",
                            "kind": "LinkedField",
                            "name": "children",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "typeDefinition",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "LearnOpportunityV2",
                                        "kind": "LinkedField",
                                        "name": "children",
                                        "plural": true,
                                        "selections": [
                                          (v7/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "LearnOpportunityBranchTypeDefinition",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "LearnOpportunityBranchTypeDefinition",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v13/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "branchNodesTab_LearnOpportunityV2Fragment"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "materialsTab_LearnOpportunityV2Fragment"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "LearnOpportunityV2",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "root_GetRootQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LearnOpportunityV2",
                "kind": "LinkedField",
                "name": "root",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "structureDefinition",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "progressPercentage",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "extension",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "extension",
                                    "plural": false,
                                    "selections": [
                                      (v12/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ContractPartner",
                                            "kind": "LinkedField",
                                            "name": "contractPartner",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "ContractPartnerData",
                                                "kind": "LinkedField",
                                                "name": "data",
                                                "plural": false,
                                                "selections": [
                                                  (v16/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "linkToAGB",
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              },
                                              (v7/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "PublishedConstellationRootExtensionExtension",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v4/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "unlockInfo",
                                    "plural": false,
                                    "selections": [
                                      (v12/*: any*/),
                                      (v5/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "firstContentId",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "firstContentCoordinatesIndexPath",
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "UnlockInfoDemo",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "StreamFile",
                                    "kind": "LinkedField",
                                    "name": "trailer",
                                    "plural": false,
                                    "selections": (v14/*: any*/),
                                    "storageKey": null
                                  },
                                  (v8/*: any*/),
                                  (v9/*: any*/),
                                  (v10/*: any*/)
                                ],
                                "type": "PublishedRootExtensionImpl",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "viewerTreeState",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              (v5/*: any*/),
                              (v11/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "LearnOpportunityRootStructureDefinition",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "typeDefinition",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LearnOpportunityV2",
                            "kind": "LinkedField",
                            "name": "children",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "typeDefinition",
                                "plural": false,
                                "selections": [
                                  (v12/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "LearnOpportunityV2",
                                        "kind": "LinkedField",
                                        "name": "children",
                                        "plural": true,
                                        "selections": [
                                          (v7/*: any*/),
                                          (v15/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "shortDescription",
                                            "storageKey": null
                                          },
                                          (v17/*: any*/),
                                          (v18/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "lengthInSecondsV2",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "typeDefinition",
                                            "plural": false,
                                            "selections": [
                                              (v12/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v19/*: any*/),
                                                  (v20/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "task",
                                                    "plural": false,
                                                    "selections": [
                                                      (v12/*: any*/),
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "status",
                                                        "storageKey": null
                                                      },
                                                      (v7/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "type": "LearnAsyncContentTypeDefinition",
                                                "abstractKey": null
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v19/*: any*/),
                                                  (v20/*: any*/)
                                                ],
                                                "type": "LearnOpportunityELearningContentTypeDefinition",
                                                "abstractKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "attachmentsV2",
                                            "plural": true,
                                            "selections": [
                                              (v12/*: any*/),
                                              (v7/*: any*/),
                                              (v2/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "File",
                                                    "kind": "LinkedField",
                                                    "name": "file",
                                                    "plural": false,
                                                    "selections": [
                                                      (v6/*: any*/),
                                                      (v16/*: any*/),
                                                      (v7/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "type": "DefaultFileAttachment",
                                                "abstractKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "LearnOpportunityBranchTypeDefinition",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v7/*: any*/),
                              (v15/*: any*/),
                              (v17/*: any*/),
                              (v18/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "LearnOpportunityBranchTypeDefinition",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v13/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "LearnOpportunityV2",
            "abstractKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d7e12d1ef0961f0ef54a7f5bf850aa3c",
    "id": null,
    "metadata": {},
    "name": "root_GetRootQuery",
    "operationKind": "query",
    "text": "query root_GetRootQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on LearnOpportunityV2 {\n      root {\n        ...RootProgress_LearnOpportunityV2Fragment\n        structureDefinition {\n          __typename\n          title\n          ... on LearnOpportunityRootStructureDefinition {\n            extension {\n              __typename\n              ... on PublishedRootExtensionImpl {\n                reducedData {\n                  receivableGamificationPoints\n                  isIHK\n                }\n                unlockInfo {\n                  __typename\n                  kind\n                }\n                trailer {\n                  url\n                  id\n                }\n                product {\n                  id\n                  title\n                }\n                learnGoals\n                ihkState\n              }\n            }\n            viewerTreeState {\n              __typename\n              kind\n              ... on IsStartedViewerTreeState {\n                headContentId\n              }\n            }\n          }\n        }\n        typeDefinition {\n          __typename\n          ... on LearnOpportunityBranchTypeDefinition {\n            children {\n              typeDefinition {\n                __typename\n                ... on LearnOpportunityBranchTypeDefinition {\n                  children {\n                    id\n                  }\n                }\n              }\n              id\n            }\n          }\n        }\n        instructorsV2 {\n          edges {\n            __typename\n          }\n        }\n        ...branchNodesTab_LearnOpportunityV2Fragment\n        ...materialsTab_LearnOpportunityV2Fragment\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment RootProgress_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  image {\n    url\n    id\n  }\n  structureDefinition {\n    __typename\n    title\n    ... on LearnOpportunityRootStructureDefinition {\n      progressPercentage\n      extension {\n        __typename\n        ... on PublishedRootExtensionImpl {\n          extension {\n            __typename\n            ... on PublishedConstellationRootExtensionExtension {\n              contractPartner {\n                data {\n                  name\n                  linkToAGB\n                }\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment branchNodesTab_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  id\n  structureDefinition {\n    __typename\n    title\n    ... on LearnOpportunityRootStructureDefinition {\n      extension {\n        __typename\n        ... on PublishedRootExtensionImpl {\n          reducedData {\n            isIHK\n          }\n          ihkState\n        }\n      }\n    }\n  }\n  ...branchNodesTree_LearnOpportunityV2Fragment\n}\n\nfragment branchNodesTree_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  typeDefinition {\n    __typename\n    ... on LearnOpportunityBranchTypeDefinition {\n      children {\n        id\n        image {\n          url\n          id\n        }\n        structureDefinition {\n          __typename\n          title\n        }\n        indexPath\n        typeDefinition {\n          __typename\n          ... on LearnOpportunityBranchTypeDefinition {\n            children {\n              id\n              image {\n                url\n                id\n              }\n              shortDescription\n              structureDefinition {\n                __typename\n                title\n              }\n              indexPath\n              lengthInSecondsV2\n              ...contentCard_LearnOpportunityV2Fragment\n            }\n          }\n        }\n      }\n    }\n  }\n  structureDefinition {\n    __typename\n    title\n    ... on LearnOpportunityRootStructureDefinition {\n      viewerTreeState {\n        __typename\n        kind\n        ... on IsStartedViewerTreeState {\n          headContentId\n        }\n      }\n      extension {\n        __typename\n        ... on PublishedRootExtensionImpl {\n          unlockInfo {\n            __typename\n            kind\n            ... on UnlockInfoDemo {\n              firstContentId\n              firstContentCoordinatesIndexPath\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment contentCard_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  id\n  image {\n    url\n    id\n  }\n  shortDescription\n  structureDefinition {\n    __typename\n    title\n  }\n  indexPath\n  lengthInSecondsV2\n  typeDefinition {\n    __typename\n    ... on LearnAsyncContentTypeDefinition {\n      contentKind\n      extension {\n        __typename\n        ... on LearnContentExtensionImpl {\n          receivableGamificationPoints\n          receivedGamificationPoints\n          isUnlockNecessaryToStart\n        }\n      }\n      task {\n        __typename\n        status\n        id\n      }\n    }\n    ... on LearnOpportunityELearningContentTypeDefinition {\n      contentKind\n      extension {\n        __typename\n        ... on LearnContentExtensionImpl {\n          receivableGamificationPoints\n          receivedGamificationPoints\n          isUnlockNecessaryToStart\n        }\n      }\n    }\n  }\n}\n\nfragment materialsTab_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  typeDefinition {\n    __typename\n    ... on LearnOpportunityBranchTypeDefinition {\n      children {\n        typeDefinition {\n          __typename\n          ... on LearnOpportunityBranchTypeDefinition {\n            children {\n              attachmentsV2 {\n                __typename\n                id\n              }\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n  ...materialsTree_LearnOpportunityV2Fragment\n}\n\nfragment materialsTree_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  typeDefinition {\n    __typename\n    ... on LearnOpportunityBranchTypeDefinition {\n      children {\n        id\n        image {\n          url\n          id\n        }\n        structureDefinition {\n          __typename\n          title\n        }\n        indexPath\n        typeDefinition {\n          __typename\n          ... on LearnOpportunityBranchTypeDefinition {\n            children {\n              id\n              indexPath\n              attachmentsV2 {\n                __typename\n                id\n                title\n                ... on DefaultFileAttachment {\n                  file {\n                    url\n                    name\n                    id\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  structureDefinition {\n    __typename\n    title\n    ... on LearnOpportunityRootStructureDefinition {\n      viewerTreeState {\n        __typename\n        kind\n        ... on IsStartedViewerTreeState {\n          headContentId\n        }\n      }\n      extension {\n        __typename\n        ... on PublishedRootExtensionImpl {\n          unlockInfo {\n            __typename\n            kind\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3ff51498c33b0e3fec27454f605e59c7";

export default node;
